export interface TreeItem {
  id: string;
  name: string;
  base: string;
  children: TreeItem[];
}

export interface PathItem {
  id: string;
  base: string;
  parsedBase: string[];
}

export interface NodeData {
  id?: string;
  parentId?: string;
  base?: string;
}

export function arrangeIntoTree(paths: PathItem[]): TreeItem {
  const tree: TreeItem[] = [];
  for (let i = 0; i < paths.length; i++) {
    const path = paths[i];
    let currentLevel = tree;
    for (let j = 0; j < path.parsedBase.length; j++) {
      const part = path.parsedBase[j];
      const existingPath = findWhere(currentLevel, 'name', part);
      if (existingPath) {
        currentLevel = existingPath.children;
      } else {
        const newPart: TreeItem = {
          id: path.id,
          name: part,
          base: path.base,
          children: [],
        };
        currentLevel.push(newPart);
        currentLevel = newPart.children;
      }
    }
  }

  return tree[0];
}

function findWhere(array: TreeItem[], key: keyof TreeItem, value: string): TreeItem | undefined {
  let t = 0; // t is used as a counter
  while (t < array.length && array[t][key] !== value) {
    t++;
  } // find the index where the id is the as the aValue

  if (t < array.length) {
    return array[t];
  } else {
    return undefined;
  }
}

export function findNodeBaseById({ id, base, children }: TreeItem, nodeId: string): string {
  if (id === nodeId) {
    return base;
  }

  for (let i = 0; i < children.length; i++) {
    const base = findNodeBaseById(children[i], nodeId);
    if (base) {
      return base;
    }
  }

  return '';
}

export function findNodeById({ id, base, children }: TreeItem, nodeId: string, parentId = ''): NodeData | null {
  if (id === nodeId) {
    return { id, parentId, base };
  }

  for (let i = 0; i < children.length; i++) {
    const nodeData = findNodeById(children[i], nodeId, id);
    if (nodeData) {
      return nodeData;
    }
  }

  return null;
}
